import { Table } from "reactstrap";
import LotTableRow from "./LotTableRow";
const LotTable = (props) => {
  return (
    <>
     
      <Table className="table-container table-borderless responsive">
      <h2>Parking Lots</h2>
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {props.parkingLots && Array.isArray(props.parkingLots) ? (
            (console.log("props", props),
            props.parkingLots.map((parkingLot, index) => (
              <LotTableRow
                key={index}
                navigate={props.navigate}
                parkingLot={parkingLot}
                token={props.token}
                getAllLots={props.getAllLots}
              />
            )))
          ) : (
            <tr>
              <td colSpan="4">No parking lots available.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
export default LotTable;
